'use client';

import React from 'react';

import { H3 } from '@repo/ui-kit/components/core/Typography';

import TextBlock from 'strapi/component/shared/TextBlock/TextBlock';
import { FlexColumn } from 'styles/layouts';

import { TextSectionProps } from './types';

export const TextSection: React.FC<TextSectionProps> = ({ textSections }) => {
  return (
    <FlexColumn gap="40px">
      {textSections.map((item, index) => (
        <FlexColumn key={index} gap="16px">
          <H3 bold>{item.title}</H3>
          <TextBlock key={index} text={item.text} />
        </FlexColumn>
      ))}
    </FlexColumn>
  );
};
